"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __1 = require("../");
var StoreLocatorList = /** @class */ (function (_super) {
    __extends(StoreLocatorList, _super);
    function StoreLocatorList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StoreLocatorList.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.context.storeLocator.locations.map(function (location) { return _this.props.children(location, location.id === _this.context.storeLocator.selected); })));
    };
    StoreLocatorList.contextType = __1.Context;
    return StoreLocatorList;
}(React.Component));
exports.StoreLocatorList = StoreLocatorList;
//# sourceMappingURL=store-locator-list.js.map